import { Period } from '../types/GrooverTypes'

/** Resolve a period by Activity.periodId, matching either Period.id or Period.periodId. */
export const findPeriodByAnyId = (
  periods: Period[] | undefined | null,
  periodKey: string | undefined | null
): Period | undefined => {
  if (!periods?.length || !periodKey) return undefined
  return periods.find((p) => p.id === periodKey || p.periodId === periodKey)
}

/** Canonical Activity.periodId is always Period.id. */
export const resolveCanonicalPeriodId = (
  periods: Period[] | undefined | null,
  periodKey: string | undefined | null
): string => findPeriodByAnyId(periods, periodKey)?.id || ''

/** Display name for an activity period, with legacy `activity.period` fallback. */
export const getPeriodDisplayName = (
  periods: Period[] | undefined | null,
  activityPeriodId: string | undefined | null,
  legacyPeriod?: string
): string => findPeriodByAnyId(periods, activityPeriodId)?.periodName || legacyPeriod || ''

/** Canonical period fields to persist when copying activities. Returns null if unresolved. */
export const resolveCopyPeriodFields = (
  periods: Period[] | undefined | null,
  copyPeriodKey: string | undefined | null
): { periodId: string; period: string } | null => {
  const selected = findPeriodByAnyId(periods, copyPeriodKey)
  if (!selected) return null
  return { periodId: selected.id, period: selected.periodName }
}
